import { Media, Texts, Button } from "../Object";
import { Grid, Space } from "../Layout";
import { useState, useEffect, useMemo } from "react";
import { useDocumentLoadCompleted, useInterval } from "../Hooks";
import { Scroll } from '../Animation';

const Fv = () => {
  const [viewIndex, setViewIndex] = useState(0);
  let delay = 8000; // スライダーの切り替わり時間
  const isLoaded = useDocumentLoadCompleted();

  // カウンター関数
  const CounterStart = useInterval(() => {
    let index = viewIndex; // indexを取得
    let maxNum = 2; // indexの最高値
    if (index == maxNum) {
      // 現在のindexが最高値だった場合、indexを0に戻す
      index = 0; // indexの初期化
    } else {
      index = index + 1; // indexの増加
    }
    setViewIndex(index); // stateに登録
  }, delay);

  useEffect(() => {
    // 全ての要素をロードした後にカウンター開始
    if (isLoaded) {
      CounterStart;
    }
  }, [isLoaded]);


  // elment
  const CatchCopy = (props) => {
    return (
      <>
        <div className="c-fv__wrap--text">
          <Space size={["32px 0", "24px 0"]}>
            <Texts slug={`catch/list${props.index}-bottom`} class="c-text--bold c-text--main c-fv__text--sub" />
            <Texts
              slug={`catch/list${props.index}`}
              class="c-fv__text--main c-text--main c-text--bold c-text--en"
            ></Texts>
          </Space>
        </div>
      </>
    );
  };
  
  const ScrollDown = () => {
    return(
      <>
        <div>
          <Media class="c-fv__img--scroll" src="FV/scroll-down" alt="scroll-down"></Media>
        </div>
      </>
    )
  }

  // First View Image Elements
  const FvItem = (props) => {
    let active = "";
    if (viewIndex == props.index && isLoaded) {
      active = "active";
    } else {
      active = "anactive";
    }
    return (
      <>
        <li className="c-fv__items" data-state={active}>
          <CatchCopy index={props.index} />
          <Media
            class="c-fv__img--main"
            src={`FV/fv-main-list${props.index}`}
            alt="fv"
            sp="sp"
          ></Media>
        </li>
      </>
    );
  };
  let fvItems = [];
  for (let i = 0; i < 3; i++) {
    fvItems.push(<FvItem key={i} index={i}></FvItem>);
  }
  // const FvImagesMemo = useMemo(() => fvItems, [isLoaded]);

  return (
    <>
      <div className="c-fv__wrap">
        <ScrollDown />
        <ul className="c-fv__list">{fvItems}</ul>
      </div>
    </>
  );
};

export default Fv;
